import React, { useState, useEffect } from "react"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { Field, FormikProvider, useFormik } from "formik"
import { get, post } from "helpers/api_helper"
import { GET_VendorDashboardDetail, GET_VendorPoList, GET_PoFulfillmentSummary, GET_VendorPoSummary, DOWNLOAD_Po_Item_List} from "helpers/url_helper"
import { Button, Card, Col, Row, Table, Pagination, PaginationItem, PaginationLink } from "reactstrap"
import { useSelector } from "react-redux"
const VendorDashboard = () => {
  const companyid = useSelector(state => state?.Login?.currentCompanyId)
  const AuthUser = JSON.parse(localStorage.getItem("authUser"))
  const userCompanyInfo = JSON.parse(localStorage.getItem("userCompanyInfo"))
  let Cid = AuthUser?.org === true ? userCompanyInfo?.organization?.id : companyid

   
  const [totalVendoPoCount, setTotalVendoPoCount] = useState(0)
  const [totalVendoPoAmountCount, setTotalVendoPoAmountCount] = useState(0)
  const [vendorData, setVendorData] = useState([])
  const [vendorPoData, setVendorPoData] = useState([])

  const [totalVendoPoAmountFulfilledQtyCount, setTotalVendoPoAmountFulfilledQtyCount] = useState(0)
  const [totalVendoPoPendingQtyCount, setTotalVendoPoPendingQtyCount] = useState(0)
  const [totalVendoPoForFulfilledCount, setTotalVendoPoForFulfilledCount] = useState(0)
  const [vendorPoFulfillmentSummaryData, setVendorPoFulfillmentSummaryData] = useState([])
  
  const [totalVendorPoSummaryData, setTotalVendorPoSummaryData] = useState(0)
  const [totalVendoPoAmountSummaryCount, setTotalVendoPoAmountSummaryCount] = useState(0)
  const [totalVendoPoFulfilledSummaryCount, setTotalVendoPoFulfilledSummaryCount] = useState(0)
  const [totalVendoPoFulfilledAmountSummaryCount, setTotalVendoPoFulfilledAmountSummaryCount] = useState(0)
  const [totalVendoPoPendingSummaryCount, setTotalVendoPoPendingSummaryCount] = useState(0)
  const [totalVendoPoPendingAmountSummaryCount, setTotalVendoPoPendingAmountSummaryCount] = useState(0)
  
  const [isLoadingForPoList, setIsLoadingForPoList] = useState(true)
  const [isLoadingForItemWisePoList, setIsLoadingForItemWisePoList] = useState(true)
  const [isLoadingForTotalBusinessSumarry, setIsLoadingForTotalBusinessSumarry] = useState(true)
  const [isLoadingForPendingOrdersListAndQty, setIsLoadingForPendingOrdersListAndQty] = useState(true)
  
  
  const [dateRange, setDateRange] = useState([]) 
  const [dateOption, setDateOption] = useState("all")

  const [dateOptionForPoList, setDateOptionForPoList] = useState("all")
  const [dateRangeForPoList, setDateRangeForPoList] = useState([])

  const [dateOptionForFulfillmentSummary, setDateOptionForFulfillmentSummary] = useState("all")
  const [dateRangeForFulfillmentSummary, setDateRangeForFulfillmentSummary] = useState([])

  const [dateOptionForPoSummary, setDateOptionForPoSummary] = useState("all")
  const [dateRangeForPoSummary, setDateRangeForPoSummary] = useState([]) 


  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; 
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = vendorPoData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(vendorPoData.length / itemsPerPage);


  const [currentPage2, setCurrentPage2] = useState(1);
  const itemsPerPage2 = 10;
  const indexOfLastItem2 = currentPage2 * itemsPerPage2;
  const indexOfFirstItem2 = indexOfLastItem2 - itemsPerPage2;
  const currentItems2 = vendorPoFulfillmentSummaryData.slice(indexOfFirstItem2, indexOfLastItem2);
  const totalPages2 = Math.ceil(vendorPoFulfillmentSummaryData.length / itemsPerPage2);

  const [currentPage3, setCurrentPage3] = useState(1);
  const itemsPerPage3 = 10;
  const indexOfLastItem3 = currentPage3 * itemsPerPage3;
  const indexOfFirstItem3 = indexOfLastItem3 - itemsPerPage3;
  const currentItems3 = vendorData.slice(indexOfFirstItem3, indexOfLastItem3);
  const totalPages3 = Math.ceil(vendorData.length / itemsPerPage3);

  
  const formikFilter = useFormik({
    initialValues: {
      ContactID: Cid,
    },
    validateOnBlur: false,
  })

  useEffect(() => {
    if (Cid) {
      formikFilter.setFieldValue("ContactID", Cid);
    }
  
    // Only proceed if dateOption is not "custom", or if it's "custom" and two dates are selected
    const shouldFetch =
      dateOption !== "custom" ||
      (dateOption === "custom" && dateRange.length === 2);
  
    if (shouldFetch) {
      fetchVendorData();
    }
  }, [dateRange, dateOption, Cid]);

  useEffect(() => {
    if (Cid) {
      formikFilter.setFieldValue("ContactID", Cid);
    }
  
    // Only proceed if dateOption is not "custom", or if it's "custom" and two dates are selected
    const shouldFetchForPoList =
      dateOptionForPoList !== "custom" ||
      (dateOptionForPoList === "custom" && dateRangeForPoList.length === 2);
  
    if (shouldFetchForPoList) {
      fetchVendorPoData();
    }
  }, [dateOptionForPoList, dateRangeForPoList, Cid]);

  useEffect(() => {
    if (Cid) {
      formikFilter.setFieldValue("ContactID", Cid);
    }
  
    // Only proceed if dateOption is not "custom", or if it's "custom" and two dates are selected
    const shouldFetchForFulfillmentSummary =
    dateOptionForFulfillmentSummary !== "custom" ||
      (dateOptionForFulfillmentSummary === "custom" && dateRangeForFulfillmentSummary.length === 2);
  
    if (shouldFetchForFulfillmentSummary) {
      fetchVendorPoFulfillmentSummaryData();
    }
  }, [dateOptionForFulfillmentSummary, dateRangeForFulfillmentSummary, Cid]);

  useEffect(() => {
    if (Cid) {
      formikFilter.setFieldValue("ContactID", Cid);
    }
  
    // Only proceed if dateOption is not "custom", or if it's "custom" and two dates are selected
    const shouldFetchForPoSummary =
    dateOptionForPoSummary !== "custom" ||
      (dateOptionForPoSummary === "custom" && dateRangeForPoSummary.length === 2);
  
    if (shouldFetchForPoSummary) {
      fetchVendorPoSummaryData();
    }
  }, [dateOptionForPoSummary, dateRangeForPoSummary, Cid]);
 
  
  const fetchVendorData = async () => {
    let url = GET_VendorDashboardDetail

    let payload = {};
    payload.date_filter = dateOption

    if (dateOption == "custom" && dateRange.length === 2) {
      const startDate = dateRange[0].toLocaleDateString("en-CA")
      const endDate = dateRange[1].toLocaleDateString("en-CA")
      payload.from_date = startDate
      payload.to_date = endDate
    }
    setIsLoadingForItemWisePoList(true)
    try {
      payload.contactId = Cid
      const res = await post(url, payload)
      if (res && res.data) {
        setVendorData(res.data)
      }
    } catch (error) {
      console.error("Failed to fetch vendor data:", error)
    } finally {
      setIsLoadingForItemWisePoList(false)
    }
  }

  const fetchVendorPoData = async () => {
    let url = GET_VendorPoList

    let payload = {};
    payload.date_filter = dateOptionForPoList

    if (dateOptionForPoList == "custom" && dateRangeForPoList.length === 2) {
      const startDate = dateRangeForPoList[0].toLocaleDateString("en-CA")
      const endDate = dateRangeForPoList[1].toLocaleDateString("en-CA")
      payload.from_date = startDate
      payload.to_date = endDate
    }

    setIsLoadingForPoList(true)
    try {
      payload.contactId = Cid
      
      const res = await post(url,payload)
      if (res && res.data) {
        setVendorPoData(res.data)
        setTotalVendoPoAmountCount(res.total_po_amount)
        setTotalVendoPoCount(res.total_po_count)
      }
    } catch (error) {
      console.error("Failed to fetch vendor data:", error)
    } finally {
      setIsLoadingForPoList(false)
    }
  }

  const fetchVendorPoFulfillmentSummaryData = async () => {
    let url = GET_PoFulfillmentSummary

    let payload = {};
    payload.date_filter = dateOptionForFulfillmentSummary
    if (dateOptionForFulfillmentSummary == "custom" && dateRangeForFulfillmentSummary.length === 2) {
      const startDate = dateRangeForFulfillmentSummary[0].toLocaleDateString("en-CA")
      const endDate = dateRangeForFulfillmentSummary[1].toLocaleDateString("en-CA")
      payload.start_date = startDate
      payload.end_date = endDate
    }

    setIsLoadingForPendingOrdersListAndQty(true)
    try {
      payload.contactId = Cid
      const res = await post(url,payload)
      if (res && res.data) {
        setVendorPoFulfillmentSummaryData(res.data)
        setTotalVendoPoAmountFulfilledQtyCount(res.total_fulfilled_qty)
        setTotalVendoPoPendingQtyCount(res.total_pending_qty)
        setTotalVendoPoForFulfilledCount(res.total_po_count)
      }
    } catch (error) {
      console.error("Failed to fetch vendor data:", error)
    } finally {
      setIsLoadingForPendingOrdersListAndQty(false)
    }
  }

  const fetchVendorPoSummaryData = async () => {
    let url = GET_VendorPoSummary

    let payload = {};
    payload.date_filter = dateOptionForPoSummary
    if (dateOptionForPoSummary !== "all" && dateRangeForPoSummary.length === 2) {
      const startDate = dateRangeForPoSummary[0].toLocaleDateString("en-CA")
      const endDate = dateRangeForPoSummary[1].toLocaleDateString("en-CA")
      payload.from_date = startDate
      payload.to_date = endDate
       
    }

    setIsLoadingForTotalBusinessSumarry(true)
    try {
      payload.contactId = Cid
      const res = await post(url,payload)
      if (res) {
        setTotalVendorPoSummaryData(res.total_po_count)
        setTotalVendoPoAmountSummaryCount(res.total_po_amount)
        setTotalVendoPoFulfilledSummaryCount(res.fulfilled_po_count)
        setTotalVendoPoFulfilledAmountSummaryCount(res.fulfilled_po_amount)
        setTotalVendoPoPendingSummaryCount(res.pending_po_count)
        setTotalVendoPoPendingAmountSummaryCount(res.pending_po_amount)
         
      }
    } catch (error) {
      console.error("Failed to fetch vendor data:", error)
    } finally {
      setIsLoadingForTotalBusinessSumarry(false)
    }
  }


  const downloadExcel = async () => {

    let payload = {};
    payload.date_filter = dateOption
    let fileName = "";
    if (dateOption == "custom" && dateRange.length === 2) {
      const startDate = dateRange[0].toLocaleDateString("en-CA");
      const endDate = dateRange[1].toLocaleDateString("en-CA");
      payload.from_date = startDate;
      payload.to_date = endDate;
      fileName = `${startDate}_TO_${endDate}_po_item.csv`;
    }else{
      fileName = `${dateOption}_po_item.csv`;
    }

    try {
      payload.contactId = Cid
      const response = await post(DOWNLOAD_Po_Item_List, payload,
      {
        responseType: 'blob',
        headers: {
          Accept: 'text/csv',
        },
      }
      );
      const blob = new Blob([response], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
     
    } catch (err) {
      console.error("Error downloading Excel:", err);
      alert("Failed to download Excel.");
    }
  };
  
  


  const handleClear = () => {
    setDateOption("all")
  }

  const handleClearForVendorPoData = () => {
    setDateOptionForPoList("all")  
  }

  const handleClearForPoFulfillmentSummary = () => {
    setDateOptionForFulfillmentSummary("all")
  }

  const handleClearForPoSummary = () => {
    setDateOptionForPoSummary("all")
  }

  

  return (
    <div>
      <div className="page-title-box">
        <Row className="align-items-center">
          <Col md={8}>
            <h6 className="page-title">Dashboard</h6>
             
          </Col>
        </Row>
      </div>
 
      <Card className="p-3">
        <Row className="mb-2">
          <Col md={3}>
            <label>PO List</label>
            <select
              className="form-control"
              value={dateOptionForPoList}
              onChange={e => setDateOptionForPoList(e.target.value)}>
              <option value="this_month">This Month</option>
              <option value="this_quarter">This Quarter</option>
              <option value="this_fy">This FY</option>
              <option value="previous_month">Previous Month</option>
              <option value="previous_quarter">Previous Quarter</option>
              <option value="previous_fy">Previous FY</option>
              <option value="all">All Data</option>
              <option value="custom">Custom</option>
            </select>
          </Col>

          {dateOptionForPoList === "custom" && (
            <Col md={4}>
              <label>Select Date Range</label>
              <Flatpickr
                data-enable-time={false}
                value={dateRangeForPoList}
                className="form-control"
                onChange={dates => setDateRangeForPoList(dates)}
                options={{
                  mode: "range",
                  dateFormat: "Y-m-d",
                }}
              />
            </Col>
          )}

          <Col md={2} className="d-flex align-items-end">
            <Button color="secondary" onClick={handleClearForVendorPoData}>
              Clear
            </Button>
          </Col>
        </Row>

        <Table hover responsive bordered>
        <thead>
          <tr>
            <th>PO Date</th>
            <th>PO Number</th>
            <th>PO Amount</th>
            <th>PO Status</th>
          </tr>
        </thead>
        <tbody>
        {isLoadingForPoList ? (
          <tr>
            <td colSpan="4" className="text-center">Loading...</td>
          </tr>
        ) : Array.isArray(vendorPoData) && vendorPoData.length > 0 ? (
          <>
            {currentItems.map((item, index) => (
              <tr key={index}>
                <td>{item?.purchase_order_date || "-"}</td>
                <td>{item?.purchase_order_no || "-"}</td>
                <td>{item?.total ?? "-"}</td>
                <td>{item?.po_status || "-"}</td>
              </tr>
            ))}

            {/* Summary Row */}
            <tr className="font-bold bg-gray-100">
              <td>Total:</td>
              <td>{totalVendoPoCount}</td>
              <td>{totalVendoPoAmountCount}</td>
              <td></td>
            </tr>
          </>
        ) : (
          <tr>
            <td colSpan="4" className="text-center">No data available</td>
          </tr>
        )}
        </tbody>
        </Table>
        {/* Pagination Controls */}
        {totalPages > 1 && (
          <Pagination className="justify-content-center">
            <PaginationItem disabled={currentPage === 1}>
              <PaginationLink previous onClick={() => setCurrentPage(prev => prev - 1)} />
            </PaginationItem>

            {[...Array(totalPages)].map((_, i) => (
              <PaginationItem key={i} active={i + 1 === currentPage}>
                <PaginationLink onClick={() => setCurrentPage(i + 1)}>
                  {i + 1}
                </PaginationLink>
              </PaginationItem>
            ))}

            <PaginationItem disabled={currentPage === totalPages}>
              <PaginationLink next onClick={() => setCurrentPage(prev => prev + 1)} />
            </PaginationItem>
          </Pagination>
        )}
      </Card>

      <Card className="p-3">
        <Row className="mb-2">
          <Col md={3}>
            <label>Pending Orders list and Qty</label>
            <select
              className="form-control"
              value={dateOptionForFulfillmentSummary}
              onChange={e => setDateOptionForFulfillmentSummary(e.target.value)}>
              <option value="this_month">This Month</option>
              <option value="this_quarter">This Quarter</option>
              <option value="this_fy">This FY</option>
              <option value="previous_month">Previous Month</option>
              <option value="previous_quarter">Previous Quarter</option>
              <option value="previous_fy">Previous FY</option>
              <option value="all">All Data</option>
              <option value="custom">Custom</option>
            </select>
          </Col>

          {dateOptionForFulfillmentSummary === "custom" && (
            <Col md={4}>
              <label>Select Date Range</label>
              <Flatpickr
                data-enable-time={false}
                value={dateRangeForFulfillmentSummary}
                className="form-control"
                onChange={dates => setDateRangeForFulfillmentSummary(dates)}
                options={{
                  mode: "range",
                  dateFormat: "Y-m-d",
                }}
              />
            </Col>
          )}

          <Col md={2} className="d-flex align-items-end">
            <Button color="secondary" onClick={handleClearForPoFulfillmentSummary}>
              Clear
            </Button>
          </Col>
        </Row>

        <Table hover responsive bordered>
        <thead>
          <tr>
            <th>PO Date</th>
            <th>PO Number</th>
            <th>PO Amount</th>
            <th>PO Total Qty</th>
            <th>PO Fulfilled Qty</th>
            <th>Pending Qty</th>
          </tr>
        </thead>
        <tbody>
        {isLoadingForPendingOrdersListAndQty ? (
          <tr>
            <td colSpan="6" className="text-center">Loading...</td>
          </tr>
        ) : Array.isArray(vendorPoFulfillmentSummaryData) && vendorPoFulfillmentSummaryData.length > 0 ? (
          <>
            {currentItems2.map((item, index) => (
              <tr key={index}>
                <td>{item?.purchase_order_date || "-"}</td>
                <td>{item?.purchase_order_no || "-"}</td>
                <td>{item?.po_amount || "-"}</td>
                <td>{item?.total_qty ?? "-"}</td>
                <td>{item?.fulfilled_qty ?? "-"}</td>
                <td>{item?.pending_qty || "-"}</td>
              </tr>
            ))}

            {/* Summary Row */}
            <tr className="font-bold bg-gray-100">
              <td>Total:</td>
              <td>{totalVendoPoForFulfilledCount}</td>
              <td></td>
              <td></td>
              <td>{totalVendoPoAmountFulfilledQtyCount}</td>
              <td>{totalVendoPoPendingQtyCount}</td>
            </tr>
          </>
        ) : (
          <tr>
            <td colSpan="6" className="text-center">No data available</td>
          </tr>
        )} 
        </tbody>
         
        </Table>
        {/* Pagination Controls for PO Fulfillment Table */}
        {totalPages2 > 1 && (
          <Pagination className="justify-content-center">
            <PaginationItem disabled={currentPage2 === 1}>
              <PaginationLink previous onClick={() => setCurrentPage2(prev => prev - 1)} />
            </PaginationItem>

            {[...Array(totalPages2)].map((_, i) => (
              <PaginationItem key={i} active={i + 1 === currentPage2}>
                <PaginationLink onClick={() => setCurrentPage2(i + 1)}>
                  {i + 1}
                </PaginationLink>
              </PaginationItem>
            ))}

            <PaginationItem disabled={currentPage2 === totalPages2}>
              <PaginationLink next onClick={() => setCurrentPage2(prev => prev + 1)} />
            </PaginationItem>
          </Pagination>
        )}
      </Card>

      <Card className="p-3">
        <Row className="mb-2 align-items-end">
          <Col md={3}>
            <label>Item Wise Po List</label>
            <select
              className="form-control"
              value={dateOption}
              onChange={e => setDateOption(e.target.value)}>
              <option value="this_month">This Month</option>
              <option value="this_quarter">This Quarter</option>
              <option value="this_fy">This FY</option>
              <option value="previous_month">Previous Month</option>
              <option value="previous_quarter">Previous Quarter</option>
              <option value="previous_fy">Previous FY</option>
              <option value="all">All Data</option>
              <option value="custom">Custom</option>
            </select>
          </Col>

          {dateOption === "custom" && (
            <Col md={4}>
              <label>Select Date Range</label>
              <Flatpickr
                data-enable-time={false}
                value={dateRange}
                className="form-control"
                onChange={dates => setDateRange(dates)}
                options={{
                  mode: "range",
                  dateFormat: "Y-m-d",
                }}
              />
            </Col>
          )}

          <Col md={2}>
            <Button color="secondary" onClick={handleClear}>
              Clear
            </Button>
          </Col>

          <Col className="text-end">
            <Button color="primary" onClick={downloadExcel}>
              Download Excel
            </Button>
          </Col>
        </Row>

        <Table hover responsive bordered>
          <thead>
            <tr> 
              <th>Item Name</th>
              <th>Total Order Qty</th>
              <th>Total Fulfilled Qty</th>
              <th>Total Pending Qty</th>
            </tr>
          </thead>
          <tbody>
          {isLoadingForItemWisePoList ? (
              <tr>
                <td colSpan="4" className="text-center">Loading...</td>
              </tr>
            ) : currentItems3.length > 0 ? (
              currentItems3.map((item, index) => (
                <tr key={index}>
                  <td>{item?.item_name || "-"}</td>
                  <td>{item?.total_order_qty || "-"}</td>
                  <td>{item?.total_fulfilled_qty || "-"}</td>
                  <td>{item?.total_pending_qty || "-"}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center">No data available</td>
              </tr>
            )}
          </tbody>
        </Table>
        {totalPages3 > 1 && (
          <Pagination className="justify-content-center">
            <PaginationItem disabled={currentPage3 === 1}>
              <PaginationLink previous onClick={() => setCurrentPage3(prev => prev - 1)} />
            </PaginationItem>

            {[...Array(totalPages3)].map((_, i) => (
              <PaginationItem key={i} active={i + 1 === currentPage3}>
                <PaginationLink onClick={() => setCurrentPage3(i + 1)}>
                  {i + 1}
                </PaginationLink>
              </PaginationItem>
            ))}

            <PaginationItem disabled={currentPage3 === totalPages3}>
              <PaginationLink next onClick={() => setCurrentPage3(prev => prev + 1)} />
            </PaginationItem>
          </Pagination>
        )}
      </Card>

      <Card className="p-3">
        <Row className="mb-2">
          <Col md={3}>
            <label>Total Business Sumarry</label>
            <select
              className="form-control"
              value={dateOptionForPoSummary}
              onChange={e => setDateOptionForPoSummary(e.target.value)}>
              <option value="this_month">This Month</option>
              <option value="this_quarter">This Quarter</option>
              <option value="this_fy">This FY</option>
              <option value="previous_month">Previous Month</option>
              <option value="previous_quarter">Previous Quarter</option>
              <option value="previous_fy">Previous FY</option>
              <option value="all">All Data</option>
              <option value="custom">Custom</option>
            </select>
          </Col>
         
          {dateOptionForPoSummary === "custom" && (
            <Col md={4}>
              <label>Select Date Range</label>
              <Flatpickr
                data-enable-time={false}
                value={dateRangeForPoSummary}
                className="form-control"
                onChange={dates => setDateRangeForPoSummary(dates)}
                options={{
                  mode: "range",
                  dateFormat: "Y-m-d",
                }}
              />
            </Col>
          )}

          <Col md={2} className="d-flex align-items-end">
            <Button color="secondary" onClick={handleClearForPoSummary}>
              Clear
            </Button>
          </Col>
        </Row>
         
        <Table hover responsive bordered>
        <thead>
        {isLoadingForTotalBusinessSumarry ? (
        <tr>
          <td colSpan="2" className="text-center">Loading...</td>
        </tr>
        ) : (
        <>
          <tr>
            <th>Total PO</th>
            <td>{totalVendorPoSummaryData}</td>
          </tr>

          <tr>
            <th>Total PO Amount</th>
            <td>{totalVendoPoAmountSummaryCount}</td>
          </tr>

          <tr>
            <th>Total PO Fulfilled</th>
            <td>{totalVendoPoFulfilledSummaryCount}</td>
          </tr>

          <tr>
            <th>Total PO Fulfilled Amount</th>
            <td>{totalVendoPoFulfilledAmountSummaryCount}</td>
          </tr>
        </>
      )}


          {/* <tr>
            <th>Total PO Pending Fulfillment</th>
            <td>{totalVendoPoPendingSummaryCount}</td>
          </tr>

          <tr>
            <th>Total PO Amount</th>
            <td>{totalVendoPoPendingAmountSummaryCount}</td>
          </tr> */}
        </thead>
         
        </Table>
      </Card>

    </div>
  )
}

export default VendorDashboard
